import ScanConfigurationSearch from './ScanConfigurationSearch';

export default ScanConfigurationSearch;
